export function formatWithComma (num) {
  return Intl.NumberFormat('en-GB').format(Number(num))
}

export function formatWithSpaces (num) {
  return Intl.NumberFormat('fr-FR', {
    style: 'decimal',
    useGrouping: true
  }).format(Number(num))
}

export function formatCompact (num) {
  return Intl.NumberFormat('en', { notation: 'compact' }).format(Number(num))
}